import type { ReactNode } from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router'
import { useAnmeldung } from './lib/anmeldung'
import type { Werkzeug } from './lib/api'
import { Kopfzeile } from './teile/Kopfzeile'
import { AnmeldungSeite } from './seiten/Anmeldung'
import { EingangSeite } from './seiten/Eingang'
import { MandantenSeite } from './seiten/Mandanten'
import { MandantSeite } from './seiten/Mandant'
import { DokumentSeite } from './seiten/Dokument'
import { RueckmeldungenSeite } from './seiten/Rueckmeldungen'
import { RueckmeldungSeite } from './seiten/Rueckmeldung'

const werkzeuge: Werkzeug[] = ['bwa', 'jahresabschluss']

function istWerkzeug(wert: string | undefined): wert is Werkzeug {
  return wert === 'bwa' || wert === 'jahresabschluss'
}

/**
 * Rahmen für alle Ansichten innerhalb eines Werkzeugs. Die Reiterzeile
 * benennt die Seite, deshalb tragen die Seiten selbst keine Überschrift.
 */
function Werkzeugrahmen({ children }: { children: ReactNode }) {
  const { werkzeug } = useParams()
  const { auskunft } = useAnmeldung()

  if (!istWerkzeug(werkzeug)) return <Navigate to="/" replace />
  // Ein Werkzeug, das für diese Kanzlei abgeschaltet ist, gibt es auch nicht
  // über die Adresszeile.
  if (auskunft && !auskunft.werkzeuge.includes(werkzeug)) return <Navigate to="/" replace />

  return (
    <>
      <Kopfzeile werkzeug={werkzeug} />
      <main className="inhalt">{children}</main>
    </>
  )
}

export function App() {
  const { auskunft, laedt } = useAnmeldung()

  if (laedt) return <div className="laedt">Einen Moment …</div>
  if (!auskunft) return <AnmeldungSeite />

  const start = auskunft.werkzeuge[0] ?? werkzeuge[0]

  return (
    <Routes>
      <Route path="/" element={<Navigate to={`/${start}/eingang`} replace />} />
      <Route
        path="/:werkzeug/eingang"
        element={
          <Werkzeugrahmen>
            <EingangSeite />
          </Werkzeugrahmen>
        }
      />
      <Route
        path="/:werkzeug/mandanten"
        element={
          <Werkzeugrahmen>
            <MandantenSeite />
          </Werkzeugrahmen>
        }
      />
      <Route
        path="/:werkzeug/mandanten/:id"
        element={
          <Werkzeugrahmen>
            <MandantSeite />
          </Werkzeugrahmen>
        }
      />
      <Route
        path="/:werkzeug/rueckmeldungen"
        element={
          <Werkzeugrahmen>
            <RueckmeldungenSeite />
          </Werkzeugrahmen>
        }
      />
      {/* Bewusst ohne Werkzeugrahmen: in der geoeffneten Auswertung gehoert
          der Bildschirm der Auswertung, die Hauptnavigation tritt zurueck.
          Siehe Vault, Werkzeugansichten Designmuster. */}
      <Route path="/:werkzeug/dokumente/:id" element={<DokumentSeite />} />
      <Route path="/:werkzeug/rueckmeldungen/:dokumentId/:von" element={<RueckmeldungSeite />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
